import { requests } from "../helpers/api.services";
import { BASE_URL } from "../helpers/api.routes";
export const GlobalService = {
  getEnums: () => requests.get(`${BASE_URL}enums`),
};
